import TransferDetailsContextProvider from '@context/TransferDetailsContext';
import LandingPage from '@views/LandingPage';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const AppRoutes = () => {
	return (
		<Router>
			<TransferDetailsContextProvider>
				<Routes>
					<Route path="/" element={<LandingPage />} />
				</Routes>
			</TransferDetailsContextProvider>
		</Router>
	);
};

export default AppRoutes;
